import { Directive, ElementRef, HostListener, Input, Renderer2, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Directive({
  selector: '[kbxlInputBound]',
})
export class InputBoundDirective implements ControlValueAccessor {
  @Input() min: number;
  @Input() max: number;
  private _onChange: (value: number) => void;
  private _onTouched: (event: any) => void;

  constructor(@Self() private control: NgControl, private el: ElementRef, private renderer: Renderer2) {
    control.valueAccessor = this;
  }

  // Currently only supporting blur
  @HostListener('blur', ['$event'])
  onBlur(event: any) {
    const value = (this.el.nativeElement as HTMLInputElement).value.trim();
    let num = Number(value);
    num = isNaN(num) ? 0 : num;

    if (num < this.min) {
      num = this.min;
    } else if (num > this.max) {
      num = this.max;
    }

    this.writeValue(num);
    if (this.control.value !== num) {
      this._onChange(num);
    }
    this._onTouched(event);
  }

  writeValue(value: number): void {
    this.renderer.setProperty(this.el.nativeElement, 'value', value);
  }
  registerOnTouched(callback: (event: any) => void): void {
    this._onTouched = callback;
  }
  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
  }
  registerOnChange(callback: (value: number) => void): void {
    this._onChange = callback;
  }
}
